/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceReferenceRequest } from "./DeviceReferenceRequest";
import {
    DeviceReferenceRequestFromJSON,
    DeviceReferenceRequestFromJSONTyped,
    DeviceReferenceRequestToJSON,
} from "./DeviceReferenceRequest";

/**
 *
 * @export
 * @interface DeviceGroupMapDevicesRequest
 */
export interface DeviceGroupMapDevicesRequest {
    /**
     * List of devices to be added to the group.
     * @type {Array<DeviceReferenceRequest>}
     * @memberof DeviceGroupMapDevicesRequest
     */
    devicesToAdd?: Array<DeviceReferenceRequest>;
    /**
     * List of devices to be removed from the group.
     * @type {Array<DeviceReferenceRequest>}
     * @memberof DeviceGroupMapDevicesRequest
     */
    devicesToRemove?: Array<DeviceReferenceRequest>;
}

/**
 * Check if a given object implements the DeviceGroupMapDevicesRequest interface.
 */
export function instanceOfDeviceGroupMapDevicesRequest(
    value: object,
): value is DeviceGroupMapDevicesRequest {
    return true;
}

export function DeviceGroupMapDevicesRequestFromJSON(
    json: any,
): DeviceGroupMapDevicesRequest {
    return DeviceGroupMapDevicesRequestFromJSONTyped(json, false);
}

export function DeviceGroupMapDevicesRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupMapDevicesRequest {
    if (json == null) {
        return json;
    }
    return {
        devicesToAdd:
            json["devicesToAdd"] == null
                ? undefined
                : (json["devicesToAdd"] as Array<any>).map(
                      DeviceReferenceRequestFromJSON,
                  ),
        devicesToRemove:
            json["devicesToRemove"] == null
                ? undefined
                : (json["devicesToRemove"] as Array<any>).map(
                      DeviceReferenceRequestFromJSON,
                  ),
    };
}

export function DeviceGroupMapDevicesRequestToJSON(
    value?: DeviceGroupMapDevicesRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        devicesToAdd:
            value["devicesToAdd"] == null
                ? undefined
                : (value["devicesToAdd"] as Array<any>).map(
                      DeviceReferenceRequestToJSON,
                  ),
        devicesToRemove:
            value["devicesToRemove"] == null
                ? undefined
                : (value["devicesToRemove"] as Array<any>).map(
                      DeviceReferenceRequestToJSON,
                  ),
    };
}
